import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { Button } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { getPendingSlidesLocation } from 'components/StudyDashboard/ProceduresPage/pendingSlidesNavigation';
import { canQueryPendingSlides } from 'components/StudyDashboard/ProceduresPage/pendingSlidesPermissions';
import { useCurrentLabId } from 'utils/useCurrentLab';
import { usePermissions } from 'utils/usePermissions';
import UploadStepInfoCard from './UploadStepInfoCard';

const StudyPendingSlidesLinkStep = ({ studyId }: { studyId: string }) => {
  const { labId } = useCurrentLabId();
  const { hasPermission } = usePermissions();

  if (!canQueryPendingSlides({ hasPermission, studyId })) {
    return null;
  }

  return (
    <UploadStepInfoCard
      icon={<AssignmentOutlinedIcon color="secondary" fontSize="small" />}
      tone="manifest"
      title="Organize slides needing case assignment"
      description="Open Dataset in Needs case assignment to assign ingested slides to cases."
    >
      <Button size="small" variant="text" component={RouterLink} to={getPendingSlidesLocation({ labId, studyId })}>
        Open Needs case assignment
      </Button>
    </UploadStepInfoCard>
  );
};

export default StudyPendingSlidesLinkStep;
